import React, { FC, useCallback } from 'react'
import s from './MapFilters.module.sass'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { TypeFiltersByKeyListButtons, TypeFiltersByKeyOnce } from '@features/Restaurant/RestaurantFilters/model/types'
import { FilterOnceTemplate } from '@features/Restaurant/RestaurantFilters/ui/FilterOnceTemplate'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { applyFilterAndUpdate } from '@features/Restaurant/RestaurantFilters/model/actions'
import { FilterButtonsTemplate } from '@features/Restaurant/RestaurantFilters/ui/FilterButtonsTemplate'
import { FilterListTemplate } from '@features/Restaurant/RestaurantFilters/ui/FilterListTemplate'
import IconDots from '@icons/icon-three-dots.svg'
import { IconButton } from '@shared/ui/Actions/IconButton'
import { setParamsRequest } from '@pages/Listing/model/slice'

interface Props {
  onExtraButtonClick?: () => void
}

const MapFilters: FC<Props> = ({ onExtraButtonClick }) => {
  const stateFilters = useAppSelector((store) => store.features.restaurant_filters)
  const { metro: metroFilter, kitchen: kitchenFilter, establishment: establishmentFilter } = stateFilters.filters
  const dispatch = useAppDispatch()

  const handleSaveInner = useCallback(async () => {
    if (!stateFilters.ready) return
    await dispatch(applyFilterAndUpdate())
    await dispatch(setParamsRequest(stateFilters.paramsRequest))
  }, [JSON.stringify(stateFilters)])

  const isShowFilterKitchen = !stateFilters.filters.metro.visible
  const isShowBadgeExtraButton = Boolean(
    establishmentFilter.checkedList.length || (metroFilter.visible && kitchenFilter.checkedList.length),
  )

  return (
    <ErrorBoundary>
      <div className={s.filters}>
        <div className={s.filterListButtons}>
          <FilterListTemplate typeFilter={'metro'} handleSave={handleSaveInner} handleRemove={handleSaveInner} />

          {['price', 'rating'].map((typeFilter) => (
            <FilterButtonsTemplate
              key={typeFilter}
              typeFilter={typeFilter as TypeFiltersByKeyListButtons}
              handleSave={handleSaveInner}
              handleRemove={handleSaveInner}
            />
          ))}

          {isShowFilterKitchen && (
            <FilterListTemplate typeFilter={'kitchen'} handleSave={handleSaveInner} handleRemove={handleSaveInner} />
          )}

          {onExtraButtonClick && (
            <IconButton
              sizes='M'
              onClick={onExtraButtonClick}
              icon={IconDots}
              mode={'white-border'}
              className={s['extra-button']}
              data-badge={isShowBadgeExtraButton}
            />
          )}
        </div>

        <div className={s.filterButtons}>
          {(['hasBooking', 'openNow', 'afishaSelected'] as TypeFiltersByKeyOnce[]).map((typeFilter) => (
            <FilterOnceTemplate key={typeFilter} typeFilter={typeFilter} handleChange={handleSaveInner} />
          ))}
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default MapFilters
